export const getAnchorPosition = (id) => {
    const section = document.getElementById(id);
    if (!section) return null;
    const mobileForm = id === "cominciare" && window.matchMedia("(max-width: 900px)").matches;
    const target = mobileForm ? section.querySelector("[data-lead-intro]") || section : section;
    const offset = mobileForm ? (document.querySelector(".site-header")?.getBoundingClientRect().height || 0) + 20 : 24;
    return target.getBoundingClientRect().top + window.scrollY - offset;
};

export const scrollToId = (id) => {
    const top = getAnchorPosition(id);
    if (top === null) return;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (window.__lenis) window.__lenis.scrollTo(top, { duration: 1.6, immediate: reduced });
    else window.scrollTo({ top, behavior: reduced ? "instant" : "smooth" });
};

export const scrollToTop = () => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
};
